import { useEffect, useState } from 'react';

import Cookies from 'js-cookie';

import { Locale, LOCALES } from 'components/helpers/types';
import { getAnonymousId } from 'components/shared/trackers';

import { determinePreferredLocale } from './getPreferredLocale';
import { i18n } from './i18n';

export const useLocale = (): Locale => {
  const [locale, setLocale] = useState<Locale>(LOCALES.ENGLISH);
  const localeCookie = Cookies.get('locale');
  const anonId = getAnonymousId();

  useEffect(() => {
    const loadLangPref = async () => {
      const preferredLocale = await determinePreferredLocale({
        localeFromCookie: localeCookie,
        anonId,
      });

      const finalLocale = preferredLocale || LOCALES.ENGLISH;
      setLocale(finalLocale);
    };

    loadLangPref();
  }, [anonId, localeCookie]);

  useEffect(() => {
    i18n.changeLanguage(locale);
  }, [locale]);
  return locale;
};
